import { CheckCircle2, Circle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "");

export const EvidenceBadges = ({ project, size = "sm", className = "" }) => {
  const badges = project?.badges || [];
  if (!badges.length) return null;
  const compact = size === "sm";
  return (
    <ul className={`flex flex-wrap gap-1.5 ${className}`} aria-label="Evidence badges" data-testid={`evidence-badges-${project.serial || project.id}`}>
      {badges.map((b) => (
        <li key={b.key}>
          <Popover>
            <PopoverTrigger asChild>
              <button type="button" className={`inline-flex items-center gap-1 rounded-full border font-semibold transition-colors ${compact ? "text-[10px] px-2 py-0.5" : "text-xs px-3 py-1"} ${b.verified ? "bg-emerald-50 border-emerald-300 text-emerald-800 hover:bg-emerald-100" : "bg-white border-black/10 text-[#0a0d12]/45 hover:border-black/30"}`} aria-label={`${b.label}: ${b.verified ? "verified" : "not yet verified"}`} data-testid={`badge-${b.key}-${project.serial || project.id}`}>
                {b.verified ? <CheckCircle2 size={compact ? 11 : 14} /> : <Circle size={compact ? 11 : 14} />} {b.label}
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-72 text-sm" data-testid={`badge-popover-${b.key}`}>
              <div className="font-serif font-bold text-[#0a0d12]">{b.label} {b.verified ? <span className="text-emerald-700 text-xs font-sans">✓ verified</span> : <span className="text-[#0a0d12]/50 text-xs font-sans">— not yet</span>}</div>
              <p className="text-xs text-[#0a0d12]/70 mt-1 leading-relaxed">{b.what}</p>
              <dl className="mt-2 text-xs space-y-0.5">
                <div><dt className="inline font-semibold">Verified by:</dt> <dd className="inline">{b.by_role}</dd></div>
                <div><dt className="inline font-semibold">When:</dt> <dd className="inline">{b.date ? fmt(b.date) : b.verified ? "Recorded at project stage change; exact date to be published" : "Pending"}</dd></div>
                {b.note && <div><dt className="inline font-semibold">Note:</dt> <dd className="inline">{b.note}</dd></div>}
              </dl>
            </PopoverContent>
          </Popover>
        </li>
      ))}
    </ul>
  );
};
